/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner } from '../models/ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner';

export class ListAzureUnassignedNetworkInterfaces200Response {
  /**
  * The list of network interfaces
  */
  'networkInterfaces': Array<ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "networkInterfaces",
      "baseName": "networkInterfaces",
      "type": "Array<ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListAzureUnassignedNetworkInterfaces200Response.attributeTypeMap;
  }

  public constructor() {
  }
}

